module.exports = __webpack_public_path__ + "static/media/construction-g0oeX29ec.c5063098.png";